import React from 'react';
import { HeaderContainer } from './header';

const Main = (props) => {
  const { children, IsUserLoggedIn, onLogOut, history, isLoading } = props;
  return (
    <div>
      <HeaderContainer IsUserLoggedIn={IsUserLoggedIn} onLogOut={onLogOut} history={history} isLoading={isLoading}/>
      <div>{children}</div>
    </div>
  );
};

export { Main };
